exports.inject = function(module) {
  module.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/logout', {
      resolve: {
        auth: ["$q", "Auth", 'Api', function($q, Auth, Api) {
          Api.bridges.fetch().then(function(data) {
            if (data.meta.total_count === 0) {
              gtmJS.push(gtmJS.events.AUTH_LOGOUT_BEFORE_NUMBER);
            }
          });

          return Auth.logout();
        }]
      }
    });
  }]);
};



/*****************
 ** WEBPACK FOOTER
 ** ./app/authorization/logout-controller.js
 ** module id = 306
 ** module chunks = 0
 **/